<template>
  <div class="order-item" @click.stop="handle(item)">
    <el-image class="order-item_image" :style="item.pic | imgFilter" :src="item.pic" v-if="item.pic"></el-image>
    <div class="order-item_content" :style="item.pic | contentFilter">
      <h3 class="order-item_title">
        <span>{{ item.orgnName }}</span>
        <span>({{ item.majorName }})</span>
      </h3>
      <div class="order-item_subTitle">
        <span>{{ item.categoryTimeName }}</span>
        <span style="margin: 0px 5px;" v-if="item.wordAddress">|</span>
        <span>{{ item.wordAddress }}</span>
      </div>
      <p class="order-item_desc">
        <span style="width: 95%">{{ item.introduction }}</span>
        <span style="width: 5%; float: right;text-align: right;">{{ item.isOnlineName }}</span>
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "SocietyOrderItem",
    props: {
      item: {
        type: Object,
        required: true
      },
      onSuccess: Function
    },
    created() {
    },
    filters: {
      imgFilter: function(value) {
        if (value) {
          return {
            "width": "19%"
          };
        } else {
          return {
            "width": "100%"
          };
        }
      },
      contentFilter: function(value) {
        if (value) {
          return {
            "width": "80%"
          };
        } else {
          return {
            "width": "100%"
          };
        }
      }
    },
    methods: {
      handle(orgn) {
        this.$emit("ok", orgn, this.extraData);
      }
    }
  };

</script>

<style lang="less" scoped>

  .order-item {
    padding: 10px;
    cursor: pointer;
    border: 1px solid #f5efef;
    border-radius: 5px;
    margin-bottom: 5px;

    &_image {
      height: 100%;
      border: 1px solid #9e9e9e82;
      border-radius: 5px;
      margin-right: 1%;
    }

    &_content {
      display: inline-block;
    }

    &_title {
      margin: 10px 0;
    }

    &_subTitle {
      color: @regular-text-color;
    }

    &_subTitle span {
      font-size: 12px;
    }

    &_major {
      white-space: pre-line;
      font-size: 14px;
      color: @secondary-text-color;
      .text-overflow-visible-line(2);
      text-overflow: clip;
    }

    &_major span {
      display: inline-block;
      height: 25px;
      padding: 0 5px;
      margin: 3px;
      line-height: 23px;
      font-size: 12px;
      border-width: 1px;
      border-style: solid;
      border-radius: 4px;
      box-sizing: border-box;
      background-color: #f4f4f5;
      border-color: #e9e9eb;
      color: #909399;
    }

    &_desc {
      white-space: pre-line;
      font-size: 14px;
      color: @secondary-text-color;
      .text-overflow-visible-line(2);
      text-overflow: clip;
    }

    &:hover {
      border-radius: 3px;
      background: #fff;
      box-shadow: 0 10px 30px 0 rgba(136, 150, 171, 0.15);
    }
  }

</style>
